module.exports = {"(^|\\.)espnfc\\.":"/football","(^|\\.)espncricinfo\\.":"/cricket"}


/*****************
 ** WEBPACK FOOTER
 ** ../~/espn-url/hostPaths.json
 ** module id = 580
 ** module chunks = 0
 **/